export enum OrderPaymentType {
	ONLINE = 'ONLINE',
	CASH_ON_DELIVERY = 'CASH_ON_DELIVERY',
	SPLIT_PAYMENT = 'SPLIT_PAYMENT',
	BANK_TRANSFER = 'BANK_TRANSFER',
}

export enum OrderPaymentState {
	Unpaid = 'Unpaid',
	Underpayment = 'Underpayment',
	ExcessPayment = 'ExcessPayment',
	CashOnDelivery = 'CashOnDelivery',
	Paid = 'Paid',
}

export enum OrderPaymentProvider {
	PAYU = 'PAYU',
	P24 = 'P24',
	OFFLINE = 'OFFLINE',
	EPT = 'EPT',
}